module.exports = __webpack_public_path__ + "media/images/features/5/history-3-22708a0f354cf51f987c32fe07405578.jpg";